/**
 * Utility function to wrap images with data-link in anchor tags
 */
export const wrapImagesWithLinks = (html: string): string => {
  const imgRegex = /<img[^>]*data-link="[^"]*"[^>]*>/gi;

  return html.replace(imgRegex, (imgTag) => {
    const linkMatch = imgTag.match(/data-link="([^"]*)"/);
    const targetMatch = imgTag.match(/data-link-target="([^"]*)"/);

    if (!linkMatch || !linkMatch[1]) return imgTag;

    const link = linkMatch[1];
    const target = targetMatch ? targetMatch[1] : "_blank";

    const cleanedImgTag = imgTag
      .replace(/\s*data-link="[^"]*"/g, "")
      .replace(/\s*data-link-target="[^"]*"/g, "");

    return `<a href="${link}" target="${target}" class="inline-block">${cleanedImgTag}</a>`;
  });
};


